export const ROUTE_MAP: Record<string, string> = {
  "Calendario": "/calendario",
  "DetalleEquipo": "/detalle-equipo",
  "DetalleGrupo": "/detalle-grupo",
  "EntradaApp": "/entrada-app",
  "Grupos": "/grupos",
  "Jugadores": "/jugadores",
  "ListaEquipos": "/lista-equipos",
  "ListaEstadios": "/lista-estadios",
  "ListaGrupos": "/lista-grupos",
  "LoginColl": "/login-coll",
  "MenuPrincipal": "/menu-principal",
  "Partidos": "/partidos",
  "Sedes": "/sedes",
  "Selecciones": "/selecciones",
  "Empresas": "/empresas",
  "Usuarios": "/usuarios",
} as const;
